export enum IncentivePayWindow {
  TBD = 0,
  Week = 1,
  MonthCurrent = 2,
  MonthPrior = 10
}

export const IncentivePayWindowMapping: Record<IncentivePayWindow, string> = {
  [IncentivePayWindow.TBD]: 'TBD',
  [IncentivePayWindow.Week]: 'Prior Week',
  [IncentivePayWindow.MonthCurrent]: 'Month Current',
  [IncentivePayWindow.MonthPrior]: 'Month Prior'
};
